import styles from './Item.module.css';

import { useState, memo } from 'react';

import { ItemEdit } from './ItemEdit';
import { ItemShow } from './ItemShow';

const isNewItem = (id) => /^new-\d+(-[a-zA-Z0-9]+)?$/.test(id);

export const Item = memo(({ user, item, checked, onCheckboxChange, onSaveItem, onCancel, showCheckbox = false }) => {
    const [ editItem, setEditItem ] = useState(isNewItem(item.id) ? item : null);

    const handleItemChange = (e) => {
        const { name, value, type, checked } = e.target;
        const fieldValue = type === 'checkbox' ? checked : value;

        setEditItem(prev => ({ ...prev, [ name ]: fieldValue }));
    };

    const handleEditItem = () => {
        setEditItem(item);
    };

    const handleSaveItem = (edit, photo) => {
        onSaveItem(edit, photo);

        setEditItem(null);
    };

    const handleCancel = () => {
        onCancel();

        setEditItem(null);
    };

    return (
        <>
            { editItem || isNewItem(item.id) ?
                <div className={ styles.edit }>
                    <ItemEdit item={ editItem } onChange={ handleItemChange } onSaveItem={ handleSaveItem } onCancel={ handleCancel } />
                </div>
                :
                <ItemShow user={ user } item={ item } checked={ checked } onEditItem={ handleEditItem } onCheckboxChange={ onCheckboxChange } showCheckbox={ showCheckbox } />
            }
        </>
    );
});

Item.displayName = 'Item';